import { render, staticRenderFns } from "./infancy.vue?vue&type=template&id=439f351a&scoped=true"
import script from "./infancy.vue?vue&type=script&lang=js"
export * from "./infancy.vue?vue&type=script&lang=js"
import style0 from "./infancy.vue?vue&type=style&index=0&id=439f351a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439f351a",
  null
  
)

export default component.exports